export default __webpack_public_path__ + "static/media/vertical-more-icon.4d406cb9.svg";